export function handleAPIError(e) {
  window.location.href = ("/login")
}

